export const bonuses = [
  {
    number: 1,
    title: '30 Oral Rehabilitation Case Analysis Cards™',
    value: 37,
    image: 'https://cdn.magicpatterns.com/uploads/qTXcJKFGYRPoTNzmwgR5mh/BONUS_1_REHABILITATION-EN.png',
    text: 'Short educational prompts that help you structure your thinking when reviewing a rehabilitation case. Each card presents a fictional planning situation, followed by questions that help you organize information, identify missing details, and document what needs further assessment.',
    bullets: ['Individual reflection', 'Educational discussions', 'Structured case reviews'],
  },
  {
    number: 2,
    title: 'The 10-Minute Case Mapping Protocol™',
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/boJqYw772G1nC5EH3EKBZC/BONUS_2_REHABILITATION-EN.png',
    text: 'A practical worksheet to create an initial organizational map of a case: Available Information → Findings → Problems → Objectives → Priorities → Case Map. An organizational exercise, not a substitute for a comprehensive clinical assessment.',
    bullets: ['Simple 6-step sequence', 'Ideal when records are already available', 'Reusable for every case'],
  },
  {
    number: 3,
    title: 'The Prosthetic Planning Review™',
    value: 29,
    image: 'https://cdn.magicpatterns.com/uploads/9wEsNv9vEKFWdYXtUo3fKD/BONUS_3_REHABILITATION-EN.png',
    text: 'A dedicated review checklist for organizing prosthetic considerations before finalizing your documented plan.',
    bullets: ['Existing restorations & prosthetic objectives', 'Constraints and procedure dependencies', 'Laboratory communication requirements', 'Unresolved questions & follow-up'],
  },
  {
    number: 4,
    title: 'The Rehabilitation Planning Blind Spot Library™',
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/bZvpicdho4tJMD74KTkrES/BONUS_4_REHABILITATION-EN.png',
    text: 'A visual educational collection of common organizational oversights that occur when information is scattered across different documents — so you recognize the questions worth asking.',
    bullets: ['Incomplete documentation & unclear objectives', 'Missing dependencies & poorly documented assumptions', 'Incomplete communication & missing review milestones'],
  },
  {
    number: 5,
    title: 'The One-Page Rehabilitation Case Presentation™',
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/d5bsFbssRQK5wH9Qc6E3JU/BONUS_5_REHABILITATION-EN.png',
    text: 'A professional template to organize a rehabilitation case into one clear visual summary — for case discussions, your own records, or communicating the plan with your team.',
    bullets: ['Overview, findings & documented problems', 'Objectives and proposed phases', 'Outstanding questions & follow-up'],
  },
];
